var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlatform(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.242,
    height: 17.627,
    viewBox: "0 0 19.242 17.627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14112",
    "data-name": "Group 14112",
    transform: "translate(1535.41 -1074.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14111",
    "data-name": "Group 14111",
    transform: "translate(-1529.621 1074.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10958",
    "data-name": "Path 10958",
    d: "M95.847,82.453V79.536l-3.211.407v2.51Z",
    transform: "translate(-92.636 -78.924)",
    fill: "#24658b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10959",
    "data-name": "Path 10959",
    d: "M123.865,78.429h4.3V74.9l-4.3.547Z",
    transform: "translate(-119.759 -74.9)",
    fill: "#24658b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10960",
    "data-name": "Path 10960",
    d: "M95.847,108.531H92.636v2.545l3.211.536Z",
    transform: "translate(-92.636 -104.107)",
    fill: "#24658b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10961",
    "data-name": "Path 10961",
    d: "M123.865,108.531V111.7l4.3.717v-3.883Z",
    transform: "translate(-119.759 -104.107)",
    fill: "#24658b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14109",
    "data-name": "Group 14109",
    transform: "translate(-1523.649 1085.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10983",
    "data-name": "Path 10983",
    d: "M195.3,149.085h-6.611V147.7a3.305,3.305,0,1,1,6.611,0Z",
    transform: "translate(-188.254 -143.533)",
    fill: "#7bac51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10984",
    "data-name": "Path 10984",
    d: "M193.651,147.784H187.04a.348.348,0,0,1-.347-.347v-1.387a3.653,3.653,0,1,1,7.305,0v1.387a.347.347,0,0,1-.348.347Zm-6.263-.694H193.3v-1.04a2.958,2.958,0,0,0-5.916,0Z",
    transform: "translate(-186.602 -141.883)",
    fill: "#7bac51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10985",
    "data-name": "Path 10985",
    d: "M187.756,141.376a.346.346,0,0,1-.245-.1l-1.239-1.24a.347.347,0,1,1,.491-.491L188,140.782a.347.347,0,0,1-.245.593Z",
    transform: "translate(-186.17 -139.442)",
    fill: "#7bac51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10986",
    "data-name": "Path 10986",
    d: "M218.5,141.376a.347.347,0,0,1-.245-.593l1.238-1.238a.347.347,0,1,1,.491.491l-1.238,1.238a.345.345,0,0,1-.246.1Z",
    transform: "translate(-212.607 -139.442)",
    fill: "#7bac51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10987",
    "data-name": "Path 10987",
    d: "M197.653,158.256a.348.348,0,0,1-.347-.347v-.655a.347.347,0,0,1,.694,0v.655a.347.347,0,0,1-.348.347Z",
    transform: "translate(-195.376 -153.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10988",
    "data-name": "Path 10988",
    d: "M214.5,158.256a.348.348,0,0,1-.347-.347v-.655a.347.347,0,0,1,.694,0v.655a.348.348,0,0,1-.348.347Z",
    transform: "translate(-209.298 -153.873)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14110",
    "data-name": "Group 14110",
    transform: "translate(-1535.409 1083.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10989",
    "data-name": "Path 10989",
    d: "M25.186,159.969a1.484,1.484,0,0,1,.92-1.371c-.414-.685-1.209-1-2.532-.441a.666.666,0,0,1-.514,0c-3.214-1.348-3.321,2.407-2.384,4.246a1.626,1.626,0,0,0,2.412.791.49.49,0,0,1,.458,0,1.626,1.626,0,0,0,2.412-.791,4.626,4.626,0,0,0,.359-1,1.484,1.484,0,0,1-1.131-1.438Z",
    transform: "translate(-19.815 -154.949)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10990",
    "data-name": "Path 10990",
    d: "M37.876,143.476a1.516,1.516,0,0,0-.424,1.317,1.516,1.516,0,0,0,1.741-1.741A1.515,1.515,0,0,0,37.876,143.476Z",
    transform: "translate(-34.085 -142.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10991",
    "data-name": "Path 10991",
    d: "M22.847,162.142a2.47,2.47,0,0,1-1.119-.3.143.143,0,0,0-.134,0,2.206,2.206,0,0,1-1.654.217,2.141,2.141,0,0,1-1.23-1.157c-.691-1.358-.812-3.478.109-4.47.425-.458,1.242-.873,2.72-.253a.32.32,0,0,0,.246,0c1.814-.761,2.636.037,2.964.582a.348.348,0,0,1-.166.5,1.133,1.133,0,0,0,.161,2.151.348.348,0,0,1,.255.419,4.993,4.993,0,0,1-.391,1.07,2.14,2.14,0,0,1-1.23,1.157,1.764,1.764,0,0,1-.534.078Zm-1.186-1.009a.84.84,0,0,1,.391.1,1.525,1.525,0,0,0,1.119.169,1.484,1.484,0,0,0,.822-.81,3.994,3.994,0,0,0,.248-.619,1.829,1.829,0,0,1-.312-3.129c-.406-.365-1.034-.372-1.875-.02a1.016,1.016,0,0,1-.781,0c-.89-.373-1.544-.344-1.942.086-.692.745-.57,2.559,0,3.682a1.484,1.484,0,0,0,.822.81,1.523,1.523,0,0,0,1.119-.17.841.841,0,0,1,.39-.1Z",
    transform: "translate(-18.159 -153.295)",
    fill: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10992",
    "data-name": "Path 10992",
    d: "M36.039,143.507a1.861,1.861,0,0,1-.3-.023.348.348,0,0,1-.287-.287,1.863,1.863,0,0,1,2.139-2.139.348.348,0,0,1,.287.287,1.862,1.862,0,0,1-1.842,2.162Zm.428-1.438a1.172,1.172,0,0,0-.338.741,1.166,1.166,0,0,0,1.079-1.078,1.172,1.172,0,0,0-.741.336Z",
    transform: "translate(-32.432 -141.033)",
    fill: "#8f8f8f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatform);
export default __webpack_public_path__ + "static/media/platform.49a6614e.svg";
export { ForwardRef as ReactComponent };